
import React from "react";
import { Modal } from "react-bootstrap";
import { CloseIcon } from "@/utlility/icons";
import CustomForm from "./form/CustomForm";
import Image from "next/image";

const CustomModal = ({ show, onHide, categoryDetails, productDetails, image = null, title = null, alt = null }) => {
  const handleClose = () => {
    onHide();
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className={`custom-modal ${image ? "modal-with-image" : "modal-no-image"}`}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <h4 className="h3">Quick Contact</h4>
        </Modal.Title>
        <button className="close-btn" onClick={handleClose}>
          <CloseIcon />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className={`modal-body-container ${image ? "has-image" : "no-image"}`}>
          {image && (
            <div className="image-preview-column">
              <div className="image-wrapper">
                <Image
                  src={image}
                  alt={alt || "Quick Contact"}
                  title={title || "Quick Contact"}
                  fill
                  sizes="(max-width: 768px) 100vw, 350px"
                  className="modal-preview-image"
                  priority
                />
                <div className="image-overlay-gradient"></div>
              </div>
              {title && <h3 className="image-preview-title">{title}</h3>}
            </div>
          )}
          <div className="form-column">
            <CustomForm
              onHide={handleClose}
              categoryId={categoryDetails?.id}
              productId={productDetails}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
